module.exports = __webpack_public_path__ + "static/hadozee-boatswain-tarto-SJA-7fa990de966da238c08fd492481683f3.png";